import { useQuery } from '@tanstack/react-query';
import { projectConfigApi } from './project-config-api.js';

// #112 (A6): Ein Schalter, drei Anzeigeorte (Katalogbaum, Testfall-Detail, Testplan-Scope-Auswahl).
// Der Lesezugriff gehoert deshalb genau einmal hierher — sonst braeuchte jeder Ort seine eigene
// Abfrage und die drei Orte koennten unterschiedlich entscheiden.
//
// Derselbe queryKey wie im Admin-Panel: schaltet jemand den Wert dort um, invalidiert das Panel
// diesen Key und der Katalog zeigt es ohne eigenes Zutun. Solange geladen wird (oder wenn die
// Abfrage scheitert), gilt die Vorgabe „eingeblendet" — die Quell-ID darf nicht kurz aufblitzen
// und dann verschwinden, und ein Ladefehler soll nicht wie eine bewusste Abschaltung wirken.
export function useShowSourceRef(projectId: string | undefined): boolean {
  const { data } = useQuery({
    queryKey: ['project-settings', projectId],
    queryFn: () => projectConfigApi.getSettings(projectId ?? ''),
    enabled: Boolean(projectId),
  });
  return data?.show_source_ref ?? true;
}
